// Campus photo for /colleges/san-diego-state-university: CC BY 2.0, by Stuart Seeger at https://www.flickr.com/photos/stuseeger/, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3ASDSUHepnerHallPanJune2015_(cropped).jpg), checked 2026-10-02 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/san-diego-state-university/; credited under the photo.
const photo = {
    "slug": "san-diego-state-university",
    "alt": "Hepner Hall and its tower among palm trees at San Diego State University",
    "src": "/colleges/san-diego-state-university/campus-1600.webp",
    "srcSmall": "/colleges/san-diego-state-university/campus-800.webp",
    "srcMid": "/colleges/san-diego-state-university/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/san-diego-state-university/og.jpg",
    "title": "SDSUHepnerHallPanJune2015 (cropped)",
    "author": "Stuart Seeger at https://www.flickr.com/photos/stuseeger/",
    "license": "CC BY 2.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/2.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3ASDSUHepnerHallPanJune2015_(cropped).jpg",
    "read": "2026-10-02"
};

export default photo;
